module.exports = __webpack_public_path__ + "img/vodacom-generic-background-mobile.74d6e11f.png";